import { supabase } from './supabase'
export async function guidedSenderApi(workshopId,operation,fields={}) {
  const {data}=await supabase.auth.getSession()
  if(!data?.session?.access_token)throw Error('Sign in to manage sender setup.')
  const response=await fetch('/.netlify/functions/review-sender-setup',{method:'POST',headers:{'Content-Type':'application/json',Authorization:`Bearer ${data.session.access_token}`},body:JSON.stringify({workshop_id:workshopId,operation,...fields})})
  const result=await response.json()
  if(!response.ok||!result.data)throw Error(result.error||'Sender setup is unavailable.')
  return result.data
}
